export enum ReportType
{
    IndividualPayroll = 1,
    EmployeeSummary = 2,
    Events = 3,
}
